import { useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";

const Footer = () => {

  const [show, setShow] = useState(false);
  const [text, setText] = useState("");
  const [androidLink, setAndroidLink] = useState("");
  const [iosLink, setIosLink] = useState("");

  const handleClose = () => {
    setShow(false);
    setAndroidLink("");
    setIosLink("");
  };
  const handleShow = (infoText, androidLink, iosLink) => {
    setShow(true);
    setText(infoText);
    setAndroidLink(androidLink);
    setIosLink(iosLink);
  };

  return (
    <>
      <section className="footer">
        <Container>
          <Row>
            <Col sm={12}  md={2} lg={1}>
              <div className="footer-logo">
                <a href="/">
                  <img src={require("../assets/images/logo.svg").default} />
                </a>
              </div>
            </Col>
            <Col sm={6} md={4} lg={3} >
              <div className="footer-content">
                <h6>Get in Touch</h6>
                <ul>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.62 8.45C19.57 3.83 15.54 1.75 12 1.75C12 1.75 12 1.75 11.99 1.75C8.46 1.75 4.42 3.82 3.37 8.44C2.2 13.6 5.36 17.97 8.22 20.72C9.28 21.74 10.64 22.25 12 22.25C13.36 22.25 14.72 21.74 15.77 20.72C18.63 17.97 21.79 13.61 20.62 8.45ZM12 13.46C10.26 13.46 8.85 12.05 8.85 10.31C8.85 8.57 10.26 7.16 12 7.16C13.74 7.16 15.15 8.57 15.15 10.31C15.15 12.05 13.74 13.46 12 13.46Z"
                        fill="white"
                      />
                    </svg>
                    United Boda Boda Riders Cooperative Union, Seriso - Kiwafu
                    Road, Plot 7322, Kansanga, Kampala - Uganda{" "}
                  </li>
                  <li>
                  <a href="mailto:support@unionmobilityapp.com">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
                        fill="white"
                      />
                    </svg>
                    support@unionmobilityapp.com
                    </a>
                  </li>
                  <li className="toll-free-number">
                    <a href="tel:+0800280025">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M17.62 10.75C17.19 10.75 16.85 10.4 16.85 9.97998C16.85 9.60998 16.48 8.83998 15.86 8.16998C15.25 7.51998 14.58 7.13998 14.02 7.13998C13.59 7.13998 13.25 6.78998 13.25 6.36998C13.25 5.94998 13.6 5.59998 14.02 5.59998C15.02 5.59998 16.07 6.13998 16.99 7.10998C17.85 8.01998 18.4 9.14998 18.4 9.96998C18.4 10.4 18.05 10.75 17.62 10.75Z"
                        fill="white"
                      />
                      <path
                        d="M21.23 10.75C20.8 10.75 20.46 10.4 20.46 9.98C20.46 6.43 17.57 3.55 14.03 3.55C13.6 3.55 13.26 3.2 13.26 2.78C13.26 2.36 13.6 2 14.02 2C18.42 2 22 5.58 22 9.98C22 10.4 21.65 10.75 21.23 10.75Z"
                        fill="white"
                      />
                      <path
                        d="M11.05 14.95L9.2 16.8C8.81 17.19 8.19 17.19 7.79 16.81C7.68 16.7 7.57 16.6 7.46 16.49C6.43 15.45 5.5 14.36 4.67 13.22C3.85 12.08 3.19 10.94 2.71 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C10.83 13.32 10.94 13.42 11.04 13.52C11.44 13.91 11.45 14.55 11.05 14.95Z"
                        fill="white"
                      />
                      <path
                        d="M21.97 18.33C21.97 18.61 21.92 18.9 21.82 19.18C21.79 19.26 21.76 19.34 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C19.39 21.62 19.38 21.63 19.37 21.63C18.78 21.87 18.14 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C10.36 19 9.97 18.71 9.6 18.4L12.87 15.13C13.15 15.34 13.4 15.5 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                        fill="white"
                      />
                    </svg>
                    Toll Free : 0800280025
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col sm={6} md={6} lg={4}>
              <div className="footer-content left-padding">
                <h6>Support</h6>
                <ul>
                  <li>
                    <a href="/term-condition">Riders Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/account-deletion">Account Deletion Policy</a>
                  </li>
                  <li>
                    <a href="/cookies-policy">Cookies Policy</a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4}>
              <div className="footer-content social-media-div">
                <h6>Social media Links</h6>
                <div className="footer-social-links">
                  <a href="https://www.instagram.com/unionappug/" target="_blank">
                  <img src={require("../assets/images/insta.svg").default} />
                  </a>
                  <a href="https://x.com/unionappug" target="_blank">
                  <img src={require("../assets/images/twitter.svg").default} />
                  </a>
                  <a href="https://www.facebook.com/unionappug  " target="_blank">
                  <img src={require("../assets/images/facebook.svg").default} />
                  </a>
                  {/* <a href="#" target="_blank">
                  <img
                    src={require("../assets/images/youtube-icon.svg").default}
                  />
                  </a> */}
                  {/* <a href="#" target="_blank">
                  <img
                    src={require("../assets/images/tiktok-icon.svg").default}
                  />
                  </a> */}
                  <a href="https://www.linkedin.com/company/unionmobilityapp" target="_blank">
                  <img
                    src={require("../assets/images/linkedin-icon.svg").default}
                  />
                  </a>
                </div>
                <div className="footer-btns about-app-action-btn">
                  <Button className="primary-btns" onClick={()=> handleShow("Passenger", "https://play.google.com/store/apps/details?id=com.union.passenger", "https://apps.apple.com/us/app/union-request-a-ride/id6739698569")}>
                    Passenger App
                  </Button>
                  <Button className="primary-btns outline-btns" onClick={()=> handleShow("Driver", "https://play.google.com/store/search?q=union%20rider&c=apps&hl=en", "https://apps.apple.com/us/app/union-driver-rider-captain/id6739698610")}>
                    Driver App
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="footer-btm-content">
        <Container>
          <p className="mb-3">
            Personal data is processed in accordance with the Data Protection
            and Privacy Act (PDPA) under the oversight of the Personal Data
            Protection Office (PDPO), as mandated by the National Information
            Technology Authority (NITA-U).
          </p>
        </Container>
      </div>
      <section className="copyright">
        <Container>
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clipPath="url(#clip0_1660_10489)">
                <path
                  d="M8 0C3.58166 0 0 3.58166 0 8C0 12.4183 3.58166 16 8 16C12.4183 16 16 12.4183 16 8C15.9951 3.58375 12.4163 0.004875 8 0ZM8 15.2001C4.02356 15.2001 0.800062 11.9764 0.800062 8C0.800062 4.02356 4.02356 0.800062 8 0.800062C11.9764 0.800062 15.1999 4.02356 15.1999 8C15.1954 11.9746 11.9746 15.1954 8 15.2001Z"
                  fill="white"
                />
                <path
                  d="M7.99999 4.80011C8.4617 4.80242 8.9174 4.90493 9.33561 5.10058C9.75382 5.29622 10.1246 5.58033 10.4222 5.93326C10.5658 6.10123 10.8182 6.12126 10.9863 5.97783C11.1543 5.83439 11.1743 5.58183 11.0309 5.41376C9.60243 3.72854 7.07837 3.52033 5.39318 4.94864C3.70787 6.37701 3.49962 8.90114 4.92809 10.5864C6.35643 12.2715 8.88049 12.4798 10.5658 11.0515C10.7333 10.9094 10.8889 10.7539 11.0309 10.5864C11.1743 10.4182 11.1543 10.1658 10.9863 10.0223C10.8182 9.87883 10.5658 9.89883 10.4222 10.0668C9.27724 11.4082 7.26146 11.5675 5.92005 10.4223C4.57874 9.2773 4.41955 7.26151 5.56455 5.92011C5.86509 5.56809 6.23855 5.2856 6.65908 5.09221C7.0796 4.89881 7.53713 4.79913 7.99999 4.80008V4.80011Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1660_10489">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>{" "}
            KaCyber Security Technologies Limited,  2025, All rights reserved
          </p>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="rounded-bg-modal"
      >
        <Modal.Header closeButton className="border-0 p-0"></Modal.Header>
        <Modal.Body>
          <div className="about-app-action-btn text-center">
            <Button className="primary-btns">
              {text} App
            </Button>
            <div className="app-sotre-img">
              <ul>
                <li>
                  <a href={androidLink} target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img
                      src={require("../assets/images/goggle-pay.svg").default}
                    />
                  </a>
                </li>
                <li>
                  <a href={iosLink} target="_blank" rel="noopener noreferrer">
                    {" "}
                    <img
                      src={require("../assets/images/app-store.svg").default}
                    />
                  </a>
                </li>
                <li>
                  <a href="">
                    {" "}
                    <img
                      src={
                        require("../assets/images/app-galery-store.svg").default
                      }
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Footer;
